import { forwardRef } from 'react'
import HeroIcon, { HeroIconProps } from '../HeroIcon'

export default forwardRef<SVGSVGElement, HeroIconProps>((props, ref) => {
  const { type = 'solid', ...rest } = props
  return <HeroIcon ref={ref} Component={Component} {...rest} />
})

const Component = forwardRef<SVGSVGElement, any>((props, ref) => {
  return (
    <svg ref={ref} width="44" height="35" viewBox="0 0 44 35" fill="currentColor" {...props}>
      <g clipPath="url(#clip0_6241_1759)">
        <path
          d="M15.4 17.5C17.7339 17.5 19.9722 16.5781 21.6225 14.9372C23.2729 13.2962 24.2 11.0706 24.2 8.75C24.2 6.42936 23.2729 4.20376 21.6225 2.56282C19.9722 0.921872 17.7339 0 15.4 0C13.0661 0 10.8278 0.921872 9.17746 2.56282C7.52714 4.20376 6.6 6.42936 6.6 8.75C6.6 11.0706 7.52714 13.2962 9.17746 14.9372C10.8278 16.5781 13.0661 17.5 15.4 17.5ZM12.2581 20.7812C5.48625 20.7812 0 26.2363 0 32.9697C0 34.0908 0.914375 35 2.04188 35H26.9913C26.62 34.3574 26.4 33.6123 26.4 32.8125V24.0625C26.4 23.9189 26.4069 23.7754 26.4206 23.6318C24.2894 21.8545 21.5394 20.7812 18.5419 20.7812H12.2581ZM36.3 16.4062C37.5169 16.4062 38.5 17.3838 38.5 18.5938V21.875H34.1V18.5938C34.1 17.3838 35.0831 16.4062 36.3 16.4062ZM30.8 18.5938V21.875C29.5831 21.875 28.6 22.8525 28.6 24.0625V32.8125C28.6 34.0225 29.5831 35 30.8 35H41.8C43.0169 35 44 34.0225 44 32.8125V24.0625C44 22.8525 43.0169 21.875 41.8 21.875V18.5938C41.8 15.5723 39.3388 13.125 36.3 13.125C33.2612 13.125 30.8 15.5723 30.8 18.5938Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_6241_1759">
          <rect width="44" height="35" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
})
